import { useMutation, useQueryClient } from 'react-query';

import { UpdateDocChronRequestDto } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/update-doc-chron-title-request.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateDocChronologyParameters extends UpdateDocChronRequestDto {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
}

interface HookProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpdateDocChronology = ({ onSuccess, onError }: HookProps = {}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ matterId, subsetId, docChronologyId, title, relativityFields }: UpdateDocChronologyParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          title,
          ...(relativityFields !== undefined && { relativityFields }),
        } satisfies UpdateDocChronRequestDto,
      });

      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}`,
        fetchConfig,
      );

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([QueryEntity.DocChronology, { docChronologyId: variables.docChronologyId }]);
        onSuccess?.();
      },
      onError: (error: Error) => {
        onError?.(error);
      },
    },
  );
};
